import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { lightTheme } from './Themes';
import { Design, Develope } from './AllSvgs';

import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte';

const Box = styled.div`
	background-color: ${(props) => props.theme.body};
	width: 100vw;
	height: 100vh;
	position: relative;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
`;

const Main = styled.div`
	color: ${(props) => props.theme.text};
	background-color: ${(props) => props.theme.body};
	padding: 2rem;
	width: 50vw;
	height: 40vh;
	z-index: 3;
	line-height: 1.5;
	cursor: pointer;
	border-radius: 20px;
	font-family: 'Ubuntu Mono', monospace;
	display: flex;
	flex-direction: column;
	// justify-content: space-between;
`;

const Title = styled.h2`
	display: flex;
	font-size: calc(16px);

	${Main}:hover & {
		& > * {
			fill: ${(props) => props.theme.body};
		}
	}
`;

const Description = styled.div`
	color: ${(props) => props.theme.text};
	font-size: calc(0.6em + 1vw);
	padding: 0.5rem 0;

	${Main}:hover & {
		color: ${(props) => props.theme.body};
	}

	strong {
		margin-bottom: 1rem;
		text-transform: uppercase;
	}
	ul,
	p {
		margin-left: 2rem;
	}
`;

const MySkillsPage = () => {
	return (
		<ThemeProvider theme={lightTheme}>
			<Box>
				<LogoComponent theme="light" />
				<SocialIcons theme="light" />
				<PowerButton />

				<Main>
					<Title>
						<p /> Technologies I've worked on <p />
					</Title>
					<div
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							marginTop: '30px',
						}}
					>
						<div style={{ padding: '15px' }}>
							<img
								src="./next.svg"
								height={50}
								width={50}
								alt=""
								title="Next.js"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./react.svg"
								height={50}
								width={50}
								alt=""
								title="React.js"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./ts.svg"
								height={50}
								width={50}
								alt=""
								title="TypeScript"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./node.svg"
								height={50}
								width={50}
								alt=""
								title="Node.js"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./express.svg"
								height={50}
								width={50}
								alt=""
								title="Express.js"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./mongo.svg"
								height={50}
								width={50}
								alt=""
								title="MongoDB"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./chakraui.svg"
								height={50}
								width={50}
								alt=""
								title="ChakraUI"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./mui.svg"
								height={50}
								width={50}
								alt=""
								title="MaterialUI"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./html.svg"
								height={50}
								width={50}
								alt=""
								title="HTML"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img src="./css.svg" height={50} width={50} alt="" title="CSS" />
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./js.svg"
								height={50}
								width={50}
								alt=""
								title="JavaScript"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./figma.svg"
								height={50}
								width={50}
								alt=""
								title="Figma"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./postman.svg"
								height={50}
								width={50}
								alt=""
								title="PostMan"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img
								src="./azure.svg"
								height={50}
								width={50}
								alt=""
								title="MicroSoft Azure"
							/>
						</div>
						<div style={{ padding: '15px' }}>
							<img src="./cpp.svg" height={50} width={50} alt="" title="C++" />
						</div>
					</div>
				</Main>

				<BigTitle text="SKILLS" top="80%" right="30%" />
			</Box>
		</ThemeProvider>
	);
};

export default MySkillsPage;
